import React, { Component } from 'react';
import Button from 'material-ui/Button';
import OptyDialog from './OptyDialog';
import TokenDisplay from './TokenDisplay';
import TextField from 'material-ui/TextField';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, ReferenceLine } from 'recharts';
import withSubscription from './withSubscription';
import { DateTime } from 'luxon';
import { formatNumField } from './format';
import api from './api';
import bn from 'bignumber.js';
import * as r from 'ramda';
import Typography from 'material-ui/Typography';

class Auction extends Component {
  state = {
    amount: '',
    price: ''
  };

  sell() {
    function integerify(price) {
      var numerator = price;
      var denominator = 1;
      while (Math.floor(numerator) !== numerator) {
        numerator *= 10;
        denominator *= 10;
      }
      return [numerator, denominator];
    }

    api.log.handle("sell-action", async () => { // eslint-disable-line complexity
      const amount = Number(this.state.amount);
      const price = this.state.price && Number(this.state.price);
      this.setState({
        amount: '',
        price: ''
      })

      if (amount > 0) {
        const sell = Math.min(this.props.option.balance, amount);
        const underwrite = amount - sell;
        var sellOrder = api.config.auctionService.currency[this.props.network.network];
        if (price > 0) {
          var [numerator, denominator] = integerify(price);
          sellOrder += numerator.toString(16).padStart(32, '0') + denominator.toString(16).padStart(32, '0');
          if (sellOrder.length !== 106) {
            throw new Error("Invalid price: " + price + " - " + sellOrder.length);
          }
        }
        if (sell > 0) {
          await this.props.option.sell(sell, sellOrder);
        }
        if (underwrite > 0) {
          await this.props.strike[this.props.type].underwrite(underwrite, sellOrder);
        }
      }
    })
  }

  buy() {
    api.log.handle('buy-action', async () => {
      const amount = Number(this.state.amount);
      this.setState({
        amount: ''
      })
      if (amount > 0) {
        await this.props.auction.current.buy(amount);
      }
    })
  }

  render() {
    const { auction, option } = this.props;
    const { amount, price } = this.state;
    const label = this.props.type.toUpperCase() + " " + this.props.strike.label();

    return (
      <div>
        {auction.current.startTime > 0 && (
          <div style={{border:'1px solid gray'}}>
            <LineChart width={400} height={300} data={auction.current.priceCurve()}>
              <Line type="monotone" dataKey="price" stroke="#8884d8" dot={false}/>
              <Line type="monotone" dataKey="demand" stroke="#000000" yAxisId={1} dot={false}/>
              <ReferenceLine x={auction.current.offset} stroke="blue" label=""/>
              <CartesianGrid stroke="#ccc" />
              <XAxis dataKey="offset" type="number"  domain={[0, 'dataMax']} minTickGap={1} tickFormatter={tick=>DateTime.fromMillis((Number(auction.current.startTime) + tick) * 1000).toLocaleString(DateTime.TIME_SIMPLE)}/>
              <YAxis />
            </LineChart>
            Quantity: {bn(auction.current.quantityTarget).div(bn(10).pow(+option.decimals)).toString()}
            <br/>
            Start Time: {DateTime.fromMillis(auction.current.startTime * 1000).toISO()}
            <br/>
            Start Price: {String(auction.current.startPrice)} {api.config.auctionService.currency.symbol}
            <br/>
            Current Price: {String(auction.current.currentPrice)} {api.config.auctionService.currency.symbol}
            <br/>
            End Price: {String(auction.current.endPrice)} {api.config.auctionService.currency.symbol}
            <br/>
            End time: {DateTime.fromMillis(auction.current.endTime * 1000).toISO()}
            <br/>
            <TokenDisplay token={{address:api.config.auctionService.currency[this.props.network.network]}} auth={auction.auctionAddress}/>
            <Button variant='raised' color='primary' disabled={!auction.current.running} onClick={()=>this.buyDialog.run()}>Buy</Button>
          </div>
        )}
        {auction.next.startTime > 0 && (
          <div style={{border:'1px solid gray'}}>
            <h2>Next Auction</h2>
            Start Time: {DateTime.fromMillis(auction.next.startTime * 1000).toISO()}
            <br/>
            Start Price: {auction.next.startPrice.toString()} {api.config.auctionService.currency.symbol}
            <br/>
            Quantity: {bn(auction.next.quantityTarget).div(bn(10).pow(+option.decimals)).toString()}
          </div>
        )}
        <Button variant='raised' color='primary' disabled={false} onClick={()=>this.sellDialog.run()}>{bn(0).eq(option.balance) && "Underwrite & "}Sell</Button>

        <OptyDialog ref={d => {this.sellDialog = d}} title={"Sell " + label} onOK={()=>this.sell()}>
          <TextField style={{width:'100%'}} label={"How many " + label + " to sell?"} value={amount} onChange={(event)=>this.setState({amount: formatNumField(event.target.value)})} />
          <TextField style={{width:'100%'}} label={"Target sale price?"} value={price} onChange={(event)=>this.setState({price: formatNumField(event.target.value)})} />
        </OptyDialog>

        <OptyDialog ref={d => {this.buyDialog = d}} title={"Buy " + label} onOK={()=>this.buy()}>
          <TextField 
            style={{width:'100%'}} 
            label={"How much " + api.config.auctionService.currency.symbol + " to  bid?"} 
            value={amount} 
            onChange={(event)=>this.setState({amount: formatNumField(event.target.value)})}
            />
            <div style={{marginTop: '10px'}}>
          <Typography variant='caption' style={{padding: '2px'}}>
          <div style={{marginBottom:'10px'}}>
          <div><strong>Current Price:</strong> {`${formatNumField(auction.current.currentPrice, 10)} ${api.config.auctionService.currency.symbol}/Option`}</div>
          {this.state.amount && !r.isEmpty(auction.current) ?
          (<div>New End Price: {String(auction.current.endPriceWithBid(parseFloat(formatNumField(this.state.amount, 10)))) +  ' ' + api.config.auctionService.currency.symbol + '/Option'}
          </div>) : null }
          </div>
            {'Cost to buyout auction: '}
            <span style={{cursor:'pointer', color:'purple', textDecoration:'underline'}} onClick={() => this.setState({amount: String(auction.current.buyoutPrice)})}>{formatNumField(auction.current.buyoutPrice, 10)}</span>
            <div>{`Options You'll Receive: ${auction.current.buyoutAmount} @ ${formatNumField(auction.current.currentPrice, 10)} ${api.config.auctionService.currency.symbol}/Option`}</div>
          </Typography>
          </div>
        </OptyDialog>
      </div>
    );
  }
}

export default withSubscription(({ strike, type }) => ({ auction: api.auction(strike[type].address), option: api.option(strike[type].address), network: api.network }))(Auction);


// WEBPACK FOOTER //
// ./src/Auction.js